import { convertLegIdsToNumbers } from "../TripSelector/TripSelector.util";

export function orderTicketsByPrice(a: any, b: any) {
  if (a.price < b.price) {
    return -1;
  }
  if (a.price > b.price) {
    return 1;
  }
  return 0;
}

export function addAproxText(text: string, t: any): string {
  return text.includes("prox") ? text : `${t("approx")} ${text}`;
}

/* Mocks */
export function mockSummary() {
  return [
    {
      text: "Ida",
      price: "61,50 €",
      priceNumber: 61.5033,
      departure: "Plaza de la Seo, 4, Zaragoza",
      arrival: "Calle Arribas, 1, Valladolid",
      date: "18 ene",
      rangetime: "11:45 - 16:00",
      num: "1",
    },
    {
      text: "Vuelta",
      price: "48,00 €",
      priceNumber: 48.11111,
      departure: "Calle Arribas, 1, Valladolid",
      arrival: "Plaza de la Seo, 4, Zaragoza",
      date: "20 ene",
      rangetime: "9:45 - 13:00",
      num: "4",
    },
  ];
}
export function mockDeparture() {
  return {
    transports: [
      {
        transport: "Autobús urbano",
        details: [
          {
            text: "Billete a Estación de autobuses Zaragoza",
            external: true,
          },
        ],
      },
      {
        transport: "AVE Larga distancia",
        details: [
          {
            text: "AVE 19730 Zaragoza - Madrid",
            price: "49,50 €",
          },
          {
            text: "Cercanías C1 Atocha - Chamartín",
            price: "0,00 €",
          },
          {
            text: "AVE 19730 Madrid - Valladolid",
            price: "40,50 €",
          },
        ],
      },
      {
        transport: "Metro",
        details: [
          {
            text: "Billete a Chamartín",
            external: true,
          },
        ],
      },
    ],
    desglose: {
      now: "90,00 €",
      later: "0,00 €",
      total: "90,00 €",
    },
  };
}
export function mockArrival() {
  return {
    transports: [
      {
        transport: "Autobús urbano",
        details: [
          {
            text: "Billete a Valdefierro",
            external: true,
          },
        ],
      },
      {
        transport: "AVE Larga distancia",
        details: [
          {
            text: "AVE 19730 Zaragoza - Madrid",
            price: "49,90 €",
          },
          {
            text: "Cercanías C1 Atocha - Chamartín",
            price: "0,00 €",
          },
          {
            text: "AVE 19730 Madrid - Valladolid",
            price: "39,50 €",
          },
        ],
      },
      {
        transport: "Metro",
        details: [
          {
            text: "Billete a Chamartín",
            external: true,
          },
        ],
      },
      {
        transport: "Reby",
        price: "aprox 4,20 €",
      },
    ],
    desglose: {
      now: "19,50 €",
      later: "0,00 €",
      total: "19,50 €",
    },
  };
}
export function mockPost() {
  return {
    outwardJourney: {
      trip: {
        Eco: {
          co2: 0.99781500000000001,
          rating: 0,
        },
        Origin: {
          extId: "100018101",
          time: "08:00:00",
          id: "A=1@O=Madrid-Sol@X=-3703214@Y=40416877@U=80@L=100018101@",
          lon: -3.703214,
          date: "2022-08-18",
          lat: 40.416876999999999,
          type: "ST",
          name: "Calle de Salvador Dalí, 4",
        },
        LegList: {
          Leg: [
            {
              Origin: {
                extId: "100018101",
                time: "08:00:00",
                id: "A=1@O=Madrid-Sol@X=-3703214@Y=40416877@U=80@L=100018101@",
                lon: -3.703214,
                date: "2022-08-18",
                lat: 40.416876999999999,
                type: "ST",
                name: "Calle de Salvador Dalí, 4",
              },
              GisRef: {
                ref: "G|1|G@T|A=1@O=Madrid-Sol@X=-3703214@Y=40416877@U=80@L=100018101@|A=1@O=Legazpi@X=-3695169@Y=40391896@U=80@L=200001170@|18082022|80000|80900|ft|ft@0@2000@120@1@100@1@@0@@@@@false@0@-1@0@-1@-1@$f@$f@$f@$f@$f@$§bt@0@2000@120@1@100@1@@0@@@@@false@0@-1@0@-1@-1@$f@$f@$f@$f@$f@$§tf@$f@$f@$f@$t@0@40000@120@2@100@1@@0@@@@@false@0@-1@0@-1@-1@$f@$§||||",
              },
              Destination: {
                extId: "200001170",
                time: "08:09:00",
                id: "A=1@O=Legazpi@X=-3695169@Y=40391896@U=80@L=200001170@",
                lon: -3.6951689999999999,
                date: "2022-08-18",
                lat: 40.391896000000003,
                type: "ST",
                name: "Legazpi",
              },
              Product: [
                {
                  name: "bolt",
                },
              ],
              idx: 0,
              type: "TAXI",
              name: "bolt",
            },
          ],
        },
        checksum: "2a8b1c18_3",
        Destination: {
          extId: "200001170",
          time: "08:09:00",
          id: "A=1@O=Legazpi@X=-3695169@Y=40391896@U=80@L=200001170@",
          lon: -3.6951689999999999,
          date: "2022-08-18",
          lat: 40.391896000000003,
          type: "ST",
          name: "Legazpi",
        },
        TariffResult: {
          fareSetItem: [
            {
              param: [
                {
                  name: "NAME",
                  value: "Movitaxi Pricing",
                },
                {
                  name: "secId",
                  value: "C-0:0",
                },
                {
                  name: "secIdEnd",
                  value: "C-0:0",
                },
                {
                  name: "secIds",
                  value: "C-0:0",
                },
              ],
              fareItem: [
                {
                  ticket: [
                    {
                      param: [
                        {
                          name: "STATUS",
                          value: "AVAILABLE",
                        },
                        {
                          name: "BOOKING_CONTEXT",
                          value:
                            "eyJ0eXBlIjoibW92aXRheGkiLCJ2ZXJzaW9uIjoiMS4xMCIsImJ1ZGdldElkIjoiOTFjMzNlZjctMzBlMi00MDgzLThhZjYtOTU5MjQ1NzA5NGIxIn0=",
                        },
                        {
                          name: "PROVIDER_ID",
                          value: "taxi",
                        },
                        {
                          name: "PROVIDER_NAME",
                          value: "Taxi",
                        },
                      ],
                      externalContent: {
                        content:
                          "ZXlKMGVYQmxJam9pYlc5MmFYUmhlR2tpTENKMlpYSnphVzl1SWpvaU1TNHhNQ0lzSW1KMVpHZGxkRWxrSWpvaU9URmpNek5sWmpjdE16QmxNaTAwTURnekxUaGhaall0T1RVNU1qUTFOekE1TkdJeEluMD0=",
                        provider: "taxi",
                        contentType: "XBOOK_CTX",
                        text: "Ver oferta",
                      },
                      cur: "EUR",
                      name: "Movitaxi ticket",
                      price: 1268,
                      shpCtx:
                        "eyJ0eXBlIjoibW92aXRheGkiLCJ2ZXJzaW9uIjoiMS4xMCIsImJ1ZGdldElkIjoiOTFjMzNlZjctMzBlMi00MDgzLThhZjYtOTU5MjQ1NzA5NGIxIn0=",
                    },
                  ],
                },
              ],
              toLegId: 0,
              name: "Movitaxi Pricing",
              fromLegId: 0,
            },
          ],
        },
      },
      selectedTariff: [
        {
          idLeg: 0,
          provider: "bolt",
          contextType: "BOOKEE_CONTEXT",
          tickets: [
            {
              context:
                "eyJ0eXBlIjoibW92aXRheGkiLCJ2ZXJzaW9uIjoiMS4xMCIsImJ1ZGdldElkIjoiOTFjMzNlZjctMzBlMi00MDgzLThhZjYtOTU5MjQ1NzA5NGIxIn0=",
            },
          ],
        },
      ],
    },
    travellers: [
      {
        type: "ADULT",
      },
      {
        type: "CHILD",
      },
      {
        type: "BABY",
      },
    ],
  };
}

/**
 * Funcion para convertir el precio string a numerico
 * @param price
 * @returns
 */
export function priceStringToNumber(price: any) {
  return parseInt(price.replace(",", "")) / 100;
}

/**
 * Funcion para convertir el precio string a numerico
 * @param price
 * @returns
 */
export function priceStringToNumber2(price: any) {
  return price.replace(/[^0-9]+/g, "") / 100;
}










export function _checkBolt (tripSelectedDetails:any,tripReturnSelectedDetails:any){
  // es solo ida
  let isBoltIda=false;
  let isBoltVuelta=false;
  let result=false;

  if(tripSelectedDetails!=null){
    let filtro=tripSelectedDetails?.summaryAmount?.departure?.transports.find((o:any) => o.line == "Bolt");
    if(filtro){
      isBoltIda=true
    }
    
  }
  if(tripReturnSelectedDetails!=null){
    let filtro=tripReturnSelectedDetails?.summaryAmount?.arrival?.transports.find((o:any) => o.line == "Bolt");
    if(filtro){
      isBoltVuelta=true
    }
  }

  if(isBoltIda || isBoltVuelta){
    result=true
  }
  return result

}
export function _checkFreenow (tripSelectedDetails:any,tripReturnSelectedDetails:any){
  // es solo ida
  let isFreenowtIda=false;
  let isFreenowVuelta=false;
  let result=false;

  if(tripSelectedDetails!=null){
    let filtro=tripSelectedDetails?.summaryAmount?.departure?.transports.find((o:any) => o.line == "Freenow");
    if(filtro){
      isFreenowtIda=true
    }
    
  }
  if(tripReturnSelectedDetails!=null){
    let filtro=tripReturnSelectedDetails?.summaryAmount?.arrival?.transports.find((o:any) => o.line == "Freenow");
    if(filtro){
      isFreenowVuelta=true
    }
  }

  if(isFreenowtIda || isFreenowVuelta){
    result=true
  }
  return result

}
export function getPaymentGatewayData(response:any){
let url="",Ds_SignatureVersion="",Ds_Signature="",Ds_MerchantParameters="";
url=response?.data?.redirect?.url



Ds_SignatureVersion=response.data.redirect.payload.Ds_SignatureVersion
Ds_Signature=response.data.redirect.payload.Ds_Signature
Ds_MerchantParameters=response.data.redirect.payload.Ds_MerchantParameters

return {url,Ds_SignatureVersion,Ds_Signature,Ds_MerchantParameters}

}

export function getPaymentGatewayDataTmb(response:any){
  let url="",Ds_SignatureVersion="",Ds_Signature="",Ds_MerchantParameters="";
  url=response.data.redirect.url
  
  Ds_SignatureVersion=response.data.redirect.payload.Ds_SignatureVersion
  Ds_Signature=response.data.redirect.payload.Ds_Signature
  Ds_MerchantParameters=response.data.redirect.payload.Ds_MerchantParameters
  
  return {url,Ds_SignatureVersion,Ds_Signature,Ds_MerchantParameters}
  
  }

  export function _isTrain(departureTrip:any,arrivalTrip:any){
    let result = false
    const transportsIdaOnlyTrain=departureTrip?.summaryAmount?.departure?.transports?.filter((i: any) =>( i?.icon=='ave'|| i?.icon=='cercanias') && i?.informative===false && i?.bonoAveFree===false )|| [];
    const transportsVueltaOnlyTrain=arrivalTrip?.summaryAmount?.arrival?.transports?.filter((i: any) => (i?.icon=='ave'|| i?.icon=='cercanias') && i?.informative===false && i?.bonoAveFree===false)|| [];

    if(transportsIdaOnlyTrain.length!==0 ||transportsVueltaOnlyTrain.length!==0 ){
      result=true;
    }

    return result

  }

  export function _mapSelectTariff(body:any,infoReserve:any,confirmedTarifs:any){
    let typeTrip=infoReserve[0].type==="departure" ?"outwardJourney":"returnJourney"

    let orderToBeReplaced=null
    let obtenerId=infoReserve.map((item:any ) => item.idTariff);
    if(confirmedTarifs!==null){
      orderToBeReplaced=confirmedTarifs[typeTrip].find((tarifa:any) => convertLegIdsToNumbers(obtenerId[0])==tarifa?.idLeg)?.orderId
    }

    let idLength=body[typeTrip].selectedTariff.findIndex((tarifa: any) => convertLegIdsToNumbers(obtenerId[0])==(tarifa.idLeg))
    let newBody={
      ...body,
      [typeTrip]:{
        ...body[typeTrip],
        //selectedTariff:filtro
      },
      payReturn: typeTrip==="outwardJourney" ?false:true,
      indexToPay: idLength,
      ...(orderToBeReplaced ? { orderToBeReplaced: orderToBeReplaced } : {})
    } 

    return newBody

  }




  export function checkAllPaidTrips(arr1:any, arr2:any)  {
    // Utilizamos `every` para verificar si todos los objetos en cada array tienen isPaidTrip en true

    let anyPaid=false,allInArray1=false,allInArray2=false,allPaid=false;
  if(arr1.length!=0 &&arr2.length==0 ){
      allInArray1 = arr1.some((item:any ) => item.status !== "PAID");
      anyPaid= allInArray1;
    //Solo tenemos viaje trenes no normales
    }else if(arr1.length===0 &&arr2.length!==0 ){
      allInArray2 = arr2.some((item:any )  => item.status !== "PAID");
      anyPaid= allInArray2;
    //Tenemos ambas cosas  
    }else if(arr1.length!==0 &&arr2.length!==0){
      allInArray1 = arr1.some((item:any ) => item.status !== "PAID");
      allInArray2 = arr2.some((item:any )  => item.status !== "PAID");
      anyPaid=allInArray1 && allInArray2;
    }

    //Solo tenemos viaje normales no trenes
    if(arr1.length!=0 &&arr2.length==0 ){
      allInArray1 = arr1.every((item:any ) => item.paymentStatus === "SUCCESS" || item.paymentStatus === "CONFIRMED");
      allPaid= allInArray1;
    //Solo tenemos viaje trenes no normales
    }else if(arr1.length===0 &&arr2.length!==0 ){
      allInArray2 = arr2.every((item:any )  => item.paymentStatus === "SUCCESS" || item.paymentStatus === "CONFIRMED");
      allPaid= allInArray2;
    //Tenemos ambas cosas  
    }else if(arr1.length!==0 &&arr2.length!==0){
      allInArray1 = arr1.every((item:any ) => item.paymentStatus === "SUCCESS" || item.paymentStatus === "CONFIRMED");
      allInArray2 = arr2.every((item:any )  => item.paymentStatus === "SUCCESS" || item.paymentStatus === "CONFIRMED");
      allPaid=allInArray1 && allInArray2;
    }
    

     /*if(Array.isArray(arr1) && arr1.length > 0){
      //discountApplied
      let isDiscountApplied=arr1.some(objeto => objeto.isDiscountApplied === true);
     
      let isPaidTrip=arr1.some(objeto => objeto.paymentStatus === "SUCCESS");
      if(isDiscountApplied===true && isPaidTrip===true){
        anyPaid=true
      }else if(allInArray1===true){
        anyPaid=true
      }
     }

     if(Array.isArray(arr2) && arr2.length > 0){
      //discountApplied
      let isDiscountApplied=arr2.some(p => p.isDiscountApplied === true);
     
      let isPaidTrip=arr2.some(p => p.paymentStatus === "SUCCESS");
      if(isDiscountApplied===true && isPaidTrip===true){
        anyPaid=true
      }else if(allInArray1===true){
        anyPaid=true
      }
     }*/

  
    // Si ambos arrays cumplen la condición, retorna true, de lo contrario false
    return {allPaid,anyPaid};


  }


  export function getConfirmedTarifs(data:any,)  {
    const outwardJourney = [] as any;
    const returnJourney = [] as any;

    // Verifica y obtiene selectedTariff del nodo outwardJourney si existe, agregando tipo 'outward'
    if (data.outwardJourney && data.outwardJourney.selectedTariff) {
      data.outwardJourney.selectedTariff.forEach((tarifa: any) => {
        outwardJourney.push({ ...tarifa});
      });
    }
  
    // Verifica y obtiene selectedTariff del nodo returnJourney si existe, agregando tipo 'return'
    if (data.returnJourney && data.returnJourney.selectedTariff) {
      data.returnJourney.selectedTariff.forEach((tarifa: any) => {
        returnJourney.push({ ...tarifa });
      });
    }
  
    return {outwardJourney,returnJourney};
  }


  
  export function getConfirmedTarifsPost(data:any,)  {
    const outwardJourney = [] as any;
    const returnJourney = [] as any;

    // Verifica y obtiene selectedTariff del nodo outwardJourney si existe, agregando tipo 'outward'
    if (data.direction==="outward") {
      outwardJourney.push({
        idLeg:data.idLeg,
        orderId:data.orderId,
        status:data.tickets[0].status

    })
    }else{
      returnJourney.push({
        idLeg:data.idLeg,
        orderId:data.orderId,
        status:data.tickets[0].status
    })
    }
    return {outwardJourney,returnJourney};
  }
  
  

  